import('./bootstrap')
    .then(function (bootstrap) { return bootstrap.default(); })
    .catch(function (error) { return console.error(error); });
